export function fmtDate(d, lang = "ar") {
  if (!d) return "";
  try {
    return new Intl.DateTimeFormat(lang === "ar" ? "ar-SA-u-nu-latn" : "en-US", {
      year: "numeric", month: "long", day: "numeric",
    }).format(new Date(d));
  } catch (e) { return ""; }
}

export function fmtTime(d, lang = "ar") {
  if (!d) return "";
  try {
    return new Intl.DateTimeFormat(lang === "ar" ? "ar-SA-u-nu-latn" : "en-US", {
      hour: "2-digit", minute: "2-digit",
    }).format(new Date(d));
  } catch (e) { return ""; }
}

export function fmtRelative(d, lang = "ar") {
  if (!d) return "";
  const date = new Date(d);
  const now = new Date();
  const sameDay = (a, b) => a.toDateString() === b.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const time = fmtTime(d, lang);
  if (sameDay(date, now)) return lang === "ar" ? `اليوم — ${time}` : `Today — ${time}`;
  if (sameDay(date, yesterday)) return lang === "ar" ? `أمس — ${time}` : `Yesterday — ${time}`;
  return fmtDate(d, lang);
}

export function wsLabel(labels, key, lang, fallback) {
  const l = labels?.[key];
  if (!l) return fallback;
  return (lang === "ar" ? l.ar || l.en : l.en || l.ar) || fallback;
}

export const RANK_STYLES = {
  1: { bg: "linear-gradient(135deg,#FFC83D,#FFAE32)", color: "#3A2400", glow: "0 0 14px rgba(255,200,61,0.55)" },
  2: { bg: "linear-gradient(135deg,#E8ECF3,#B8C2D4)", color: "#2A3242", glow: "0 0 12px rgba(200,210,230,0.45)" },
  3: { bg: "linear-gradient(135deg,#E8A469,#B06A2B)", color: "#3A1E05", glow: "0 0 12px rgba(205,127,50,0.45)" },
  4: { bg: "linear-gradient(135deg,#9C42F5,#7625D8)", color: "#fff", glow: "0 0 12px rgba(156,66,245,0.45)" },
  5: { bg: "linear-gradient(135deg,#9C42F5,#7625D8)", color: "#fff", glow: "0 0 12px rgba(156,66,245,0.45)" },
};
